export enum InfoBarColorScheme {
  BLUE = 'blue',
}
